<div class="flex flex-1 flex-col">
	<div class="flex flex-1 items-center justify-start">
		<input
			type="checkbox"
			class="ml-3.5 mr-4"
			(click)="toggleAllLots()"
			[checked]="lots?.length === selectedLots?.length && lots?.length > 0"
			[disabled]="!(lots?.length > 0)"
			[testHook]="testHooks.AllLotsCheckbox"
		/>
		<ui-button
			label="Purchase Selected {{ selectedLots.length }}"
			[disabled]="!(selectedLots?.length > 0)"
			(click)="purchaseSelected()"
			teranetLoginGuard
			preset="MEDIUM_EMPHASIS"
			[testHook]="testHooks.PurchaseSelectButton"
		/>

		<app-checkbox
			class="ml-2"
			type="clear"
			[ngModel]="includeDeleted"
			(ngModelChange)="toggleIncludeDeleted($event)"
			[label]="'Include deleted'"
			[testHook]="testHooks.IncludeDeletedCheckbox"
		></app-checkbox>
	</div>

	<div
		*ngFor="let pin of lots"
		class="flex border rounded-md mt-4 p-4"
		[ngClass]="{ 'bg-gray-200': selectedLot(pin.pin) }"
	>
		<div
			*ngIf="
				pin?.parcels?.length > 0 ||
				(parcelPurchaseStates &&
					parcelPurchaseStates[pin.pin]?.state === purchaseStates.PURCHASING)
			"
			class="flex"
		>
			<div class="flex justify-center items-center mr-5">
				<app-icon
					*ngIf="pin?.parcels?.length > 0"
					[icon]="ICON.PDF"
					class="cursor-pointer text-red-darker text-5xl"
					(click)="openPDF(pin.parcels[0], pin.pin)"
					[testHook]="testHooks.PdfIcon"
				></app-icon>
				<app-icon
					*ngIf="
						parcelPurchaseStates &&
						parcelPurchaseStates[pin.pin]?.state === purchaseStates.PURCHASING
					"
					[icon]="ICON.LOADING"
					[spin]="true"
					[testHook]="testHooks.LoadingIcon"
				></app-icon>
			</div>
			<div class="flex flex-col border-r pin-type-col pr-4">
				<div class="flex justify-between">
					<span>Pin:</span><span>{{ pin.pin }}</span>
				</div>
				<div class="flex justify-between">
					<span>Type:</span><span>Regular Parcel</span>
				</div>
			</div>
			<div class="ml-4">
				<div class="flex">
					<span class="address-label">Address:</span
					><span>{{ getAddressString(pin.address) }}</span>
				</div>
				<div class="flex">
					<span class="legal-label">Legal description:</span
					><span>{{ pin.legal_desc }}</span>
				</div>
			</div>
		</div>

		<div
			*ngIf="
				!(pin?.parcels?.length > 0) &&
				parcelPurchaseStates &&
				parcelPurchaseStates[pin.pin]?.state !== purchaseStates.PURCHASING
			"
			(click)="toggleSelectLot(pin.pin)"
			class="flex"
		>
			<div class="flex justify-center items-center mr-5">
				<input
					type="checkbox"
					[checked]="selectedLot(pin.pin)"
					[testHook]="testHooks.SelectLotCheckbox"
				/>
			</div>
			<div class="flex flex-col border-r pin-type-col pr-4">
				<div class="flex justify-between">
					<span>Pin:</span><span>{{ pin.pin }}</span>
				</div>
				<div class="flex justify-between">
					<span>Type:</span><span>Regular Parcel</span>
				</div>
			</div>
			<div class="ml-4">
				<div class="flex">
					<span class="address-label">Address:</span
					><span>{{ getAddressString(pin.address) }}</span>
				</div>
				<div class="flex">
					<span class="legal-label">Legal description:</span
					><span>{{ pin.legal_desc }}</span>
				</div>
			</div>
		</div>
	</div>
</div>
